import './partials/AnimateStickyBar';
import './partials/MobileNav';
import './partials/MobileNavAnimations'
import './partials/SuperLazyLoad';
import './partials/HomepageCarousel';
import './partials/SpeakersHoverEffect';
import './partials/EdayPlayVideo';
import './partials/ProgramEvent';
import './partials/ProgramModal';
import './partials/LocationMap';
import './partials/CountDown';
import './partials/CTACountDown';
import './partials/HorizontalProgrammeScroll';


// WEBPACK FOOTER //
// ./resources/assets/js/script.js